import { render } from "./LegoRadioGroup.vue?vue&type=template&id=344318c3"
import script from "./LegoRadioGroup.vue?vue&type=script&lang=js"
export * from "./LegoRadioGroup.vue?vue&type=script&lang=js"
script.render = render

export default script